import { useEffect, useState } from 'react';
import {
    withRouter
} from 'react-router-dom';
import {
    Button,
    Thumbnail,
    Badge,
    IndexTable,
    // useIndexResourceState,
    Tooltip,

} from '@shopify/polaris';
import Language from '../../../../i18n/Language';
import cloneDeep from 'lodash-es/cloneDeep';
const t = Language;

const IndexTableImage = (props) => {
    // 通信数据
    const {
        id,
        tabKey,
        loading,
        dataList,
        obj_name,
        headings,
        getTableItemState,
        promotedBulkActions,
        tableType,
        jumpOptImgDetails,
        // openDetailCompareModal,
        // DownloadImage,
        RestoreImageData,
        // isShowProgress,
        isShowAutoState,
        isReOpt,

    } = props;

    // 源文案
    const resourceName = {
        singular: t("data"),
        plural: `${t(obj_name)}`,
    };

    const selectableOrders = dataList.filter((item) => !item.disabled);

    const [selectedResources, setSelectedResources] = useState([]);
    const [allResourcesSelected, setAllResourcesSelected] = useState(false);

    // const { selectedResources, allResourcesSelected, handleSelectionChange, clearSelection } = useIndexResourceState(selectableOrders);

    // 阻止冒泡
    const stopActionDeep = (e) => {
        e.stopPropagation();
    }

    // 选择
    const handleSelectionAction = (e, v, i) => {
        let idArr = selectableOrders.map(i => i.id);
        if (e === 'single') {
            let newArr = cloneDeep(selectedResources);
            if (v) {
                newArr.push(i)
            } else {
                newArr.splice(newArr.indexOf(i), 1);
            }
            setAllResourcesSelected(false);
            setSelectedResources(newArr);
        } else if (e === 'page') {
            setSelectedResources(v ? idArr : []);
            setAllResourcesSelected(false);
        } else if (e === 'all') {
            setSelectedResources(idArr);
            setAllResourcesSelected(true);
        } else {
            setSelectedResources([]);
            setAllResourcesSelected(false);
        }
    }

    // 清空选择
    const clearSelectionAction = () => {
        setSelectedResources([]);
        setAllResourcesSelected(false);
    }

    // // 比特转换
    // const changeBitInfo = (limit) => {
    //     let size = "";
    //     if (limit < 1 * 1024 * 1024) {
    //         //小于0.1MB，则转化成KB 
    //         size = (limit / 1024).toFixed(2) + "KB"
    //     } else if (limit < 1 * 1024 * 1024 * 1024) {
    //         //小于0.1GB，则转化成MB 
    //         size = (limit / (1024 * 1024)).toFixed(2) + "MB"
    //     } else {
    //         //其他转化成GB 
    //         size = (limit / (1024 * 1024 * 1024)).toFixed(2) + "GB"
    //     }
    //     return size;
    // }

    useEffect(() => {
        getTableItemState([selectedResources, allResourcesSelected]); // 表格选择状态
    }, [selectedResources, allResourcesSelected]);

    useEffect(() => {
        return () => {
            clearSelectionAction();
        }
    }, [tabKey, dataList, loading])

    useEffect(() => {
        let idArr = selectableOrders.map(i => i.id);
        if (isReOpt) {
            setSelectedResources(idArr);
            setAllResourcesSelected(true);
        }
    }, [isReOpt])

    // 列表内容
    const TableDataList = dataList.map((item, index) => {
        return tableType === 'manually' ? <IndexTable.Row
            id={item.id}
            key={item.id}
            selected={selectedResources.includes(item.id)}
            position={index}
            disabled={loading}
        >
            <IndexTable.Cell>
                {
                    tabKey === 0 ? (Boolean(item?.image) && typeof item.image === 'string' ?
                        <Thumbnail
                            source={JSON.parse(item.image)['src'] || ''}
                            size="small"
                            alt={JSON.parse(item.image)['alt']}
                        /> : null) : ([1, 2].includes(tabKey) && Boolean(item.image) ? <Thumbnail
                            source={item.image.src || ''}
                            size="small"
                            alt={item.image.src}
                        /> : null)
                }
            </IndexTable.Cell>
            <IndexTable.Cell>
                <div className='limit_title'>
                    {item.title}
                </div>
            </IndexTable.Cell>
            <IndexTable.Cell>
                {
                    (tabKey === 0 && Boolean(item.status)) ? <Badge>{t(item.status)}</Badge> :
                        ((tabKey === 1 || tabKey === 2) && Boolean(item.published_at) ? <Badge>{t("active")}</Badge> : <Badge>{t("draft")}</Badge>)
                }
            </IndexTable.Cell>
        </IndexTable.Row> :
            tableType === 'history' && tabKey === 0 ? <IndexTable.Row
                id={item.id}
                key={item.id}
                selected={selectedResources.includes(item.id)}
                position={index}
                disabled={loading || Boolean(item.is_delete === 1)}
            >
                <IndexTable.Cell>
                    {
                        Boolean(item.image?.length) ?
                            <Thumbnail
                                source={JSON.parse(item.image)['src']}
                                size="small"
                                alt={JSON.parse(item.image)['alt']}
                            /> : null
                    }
                </IndexTable.Cell>
                <IndexTable.Cell>
                    <div className='limit_title_table'>
                        {item.title}
                    </div>
                </IndexTable.Cell>
                <IndexTable.Cell>
                    {
                        Boolean(item.is_delete === 1) ? <Badge tone={"warning"}>{t("Deleted")}</Badge> :
                            Boolean(item.opt_alt === 3) ? <Badge tone={"attention"}>{t("Restored")}</Badge> :
                                Boolean(item.status) ? <Badge>{t(item.status)}</Badge> : null
                    }
                </IndexTable.Cell>
                <IndexTable.Cell>
                    {
                        !Boolean(item.is_delete) ? <Button onClick={(e) => {
                            stopActionDeep(e)
                            jumpOptImgDetails(item)
                        }} variant='plain' textAlign="left">{t("Details")}</Button> : null
                    }
                </IndexTable.Cell>
            </IndexTable.Row> :
                (tableType === 'history' && [1, 2].includes(tabKey)) ? <IndexTable.Row
                    id={item.id}
                    key={item.id}
                    selected={selectedResources.includes(item.id)}
                    position={index}
                    disabled={loading || Boolean(item.image?.is_delete)}
                >
                    <IndexTable.Cell>
                        {
                            Boolean(item.image) ?
                                <Thumbnail
                                    source={item.image?.is_delete === 1 ? item.image['after_file_path'] : item.image['src']}
                                    size="small"
                                    alt={item.image['alt']}
                                /> : null
                        }
                    </IndexTable.Cell>
                    <IndexTable.Cell>
                        <div className='limit_title_table'>{item.title}</div>
                    </IndexTable.Cell>
                    <IndexTable.Cell>
                        {
                            (Boolean(item.image?.is_delete === 1)) ? <Badge tone='warning'>{t("Deleted")}</Badge> :
                                // (Boolean(item.image) && (item.image.is_overdue === 1)) ? <Badge tone='warning'>{t("Expired")}</Badge> :
                                    (Boolean(item.image) && [1, 2].includes(item.image?.is_restore)) ? <Badge tone='attention'>{t("Restored")}</Badge> :
                                        Boolean(item.image) && item.opt_status > 0 ? (
                                            <div className='flex_layout badge_history'>
                                                {item.image.is_edit_alt === 1 && <Badge>{t("Alt text")}</Badge>}
                                            </div>
                                        ) : null

                        }
                    </IndexTable.Cell>
                    <IndexTable.Cell>
                        {
                            Boolean(item.image) ? Boolean(item.image?.file_type) ? <Badge>{(item.image.file_type).toUpperCase()}</Badge> : null : null
                        }
                    </IndexTable.Cell>
                    <IndexTable.Cell>
                        {
                            Boolean(item.image) ?
                                <div className='flex_layout'>
                                    {
                                        isShowAutoState ? <Tooltip content={t("This feature is only available when the 'Auto Add Image Alt Text' function is disabled.")}>
                                            <Button disabled>{t("Restore")}</Button>
                                        </Tooltip> :
                                            (!Boolean(item.is_delete) && ![1, 2].includes(item.image?.is_restore)) ? <Button
                                                onClick={(e) => {
                                                    stopActionDeep(e);
                                                    RestoreImageData(item)
                                                }}
                                                disabled={Boolean(item['downloadLoadingId'].includes(item['id']))}
                                                loading={Boolean(item['restoreLoadingId'].includes(item['id']))}
                                            >{t("Restore")}</Button> : null
                                    }
                                </div> : null
                        }
                    </IndexTable.Cell>
                </IndexTable.Row> : tableType === 'detail' ? <IndexTable.Row
                    id={item.id}
                    key={item.id}
                    selected={selectedResources.includes(item.id)}
                    position={index}
                    disabled={loading || Boolean(item.is_delete)}
                >
                    <IndexTable.Cell>
                        {
                            Boolean(item['src']) ?
                                <Thumbnail
                                    source={item.is_delete === 1 ? item?.after_file_path : item['src']}
                                    size="small"
                                    alt={item['alt']}
                                /> : null
                        }
                    </IndexTable.Cell>
                    <IndexTable.Cell>
                        <div className='flex_layout badge_history'>
                            {item.is_delete === 1 ? <Badge tone='warning'>{t("Delete")}</Badge> :
                                // (Boolean(item) && item?.is_overdue === 1) ? <Badge tone='warning'>{t("Expired")}</Badge> :
                                    (Boolean(item) && [1, 2].includes(item?.is_restore)) ? <Badge tone='attention'>{t("Restored")}</Badge> :
                                        Boolean(item) ? <>
                                            {item?.is_edit_alt === 1 && <Badge>{t("Alt text")}</Badge>}
                                        </> : null
                            }
                        </div>
                    </IndexTable.Cell>
                    <IndexTable.Cell>
                        {
                            Boolean(item.file_type) ? <Badge>{(item.file_type).toUpperCase()}</Badge> : null
                        }
                    </IndexTable.Cell>
                    <IndexTable.Cell>
                        {
                            Boolean(item) ?
                                <div className='flex_layout'>
                                    {
                                        isShowAutoState ? <Tooltip content={t("This feature is only available when the 'Auto Add Image Alt Text' function is disabled.")}>
                                            <Button disabled>{t("Restore")}</Button>
                                        </Tooltip> :
                                            (![1, 2].includes(item?.is_restore) && !Boolean(item.is_delete)) ? <Button
                                                onClick={(e) => {
                                                    stopActionDeep(e);
                                                    RestoreImageData(item);
                                                }}
                                                disabled={Boolean(item['downloadLoadingId'].includes(item['id']))}
                                                loading={Boolean(item['restoreLoadingId'].includes(item['id']))}
                                            >{t("Restore")}</Button> : null
                                    }
                                </div> : null
                        }
                    </IndexTable.Cell>
                </IndexTable.Row> : null
    });

    return (
        <div className='index_table_box' id={id}>
            <IndexTable
                resourceName={resourceName}
                itemCount={dataList.length}
                selectedItemsCount={
                    allResourcesSelected ? 'All' : selectedResources.length
                }
                onSelectionChange={handleSelectionAction}
                hasMoreItems
                promotedBulkActions={promotedBulkActions}
                headings={headings}
            // selectable={!(tableType === 'history' && tabKey === 3)}
            >
                {TableDataList}
            </IndexTable>
        </div>
    )
};


export default withRouter(IndexTableImage);